import { Component, Injector, Input, Optional } from '@angular/core';

import { ArtikelLeverancierPrijzenService } from 'src/app/core/service/artikel-leverancier-prijzen.service';
import { ArtikelLeverancierPrijzen } from 'src/app/core/dto/artikel-leverancier-prijzen';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { ArtikelLeverancier } from 'src/app/core/dto/artikel-leverancier';

@Component({
  selector: 'c-i-j-borculo-artikel-leverancier-prijzen-collection',
  templateUrl: './artikel-leverancier-prijzen-collection.component.html'/*,
    styleUrls: ['./artikel-leverancier-prijzen-collection.component.css'] */
})
export class ArtikelLeverancierPrijzenCollectionComponent extends PagedCollectionComponent<ArtikelLeverancierPrijzen> {
  columnDefinitions: ColumnDefinition[] = createColumnDefinitions<ArtikelLeverancierPrijzen>([
		{ colDef: 'prijs', prop: x => x.prijs, searchable: SearchableType.Number },
		{ colDef: 'datum', prop: x => x.datum, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

  constructor(public service: ArtikelLeverancierPrijzenService, @Optional() protected filter: Filter<ArtikelLeverancierPrijzen>, injector: Injector) {
    super('/artikelLeverancierPrijs/artikelLeverancierPrijzen', injector, ArtikelLeverancierPrijzen);

    this.initInput('artikelLeverancier', this.filterBuilder.equal(x => x.artikelLeverancier.id));
    this.orderBy = [-2];

		this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
		this.filter.onGetChipLabel(x => x.datum, () => 'Datum');
  }

  @Input() set artikelLeverancier(val: ArtikelLeverancier) { this.handleInput('artikelLeverancier', val.id); }
  
  canDelete() {
      return false;
  }

}
